var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHereIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7489 12.6053C15.0837 12.2706 15.0837 11.7269 14.7489 11.3922L10.4642 7.10742C10.1294 6.77268 9.58581 6.77268 9.25106 7.10742C8.91631 7.44217 8.91631 7.9858 9.25106 8.32055L12.9306 12.0001L9.25374 15.6796C8.91899 16.0144 8.91899 16.558 9.25374 16.8927C9.58848 17.2275 10.1321 17.2275 10.4669 16.8927L14.7516 12.608L14.7489 12.6053Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHereIco);
export default __webpack_public_path__ + "static/media/Here_ico.f21ebac90426742708c8867f3d04cf9a.svg";
export { ForwardRef as ReactComponent };